import React, { useEffect, useState } from "react";
import { LayoutHome } from "../LayoutHome";
import es_ES from "rsuite/locales/es_ES";
import {
  DatePicker,
  Panel,
  SelectPicker,
  Text,
  Drawer,
  Box,
  Modal,
  Tag,
  HStack,
  CustomProvider,
  Row,
  Col,
  Grid,
} from "rsuite";
import { Input, Card, notification, Button, Popconfirm } from "antd";
import Table from "react-bootstrap/Table";
import {
  getStockInsumo,
  getPacientesProg,
  getLugarSesion,
  getListaAsistencia,
  getListaAsistenciaTurno,
  getInsumos,
  addInsumoSesion,
  deleteInsumo,
  asignaLugar,
  getTurnos,
  getEnfermeras,
  getMaquinas,
  getHorariosTurno,
  getInsumosSesion,
  getFiltroAsignado,
  saveAsignacion,
} from "../Services/SesionHemoServices";
import {
  getFiltrosXInventario,
  saveAsignaModalidadUso,
  saveAsignaFiltro,
} from "../Services/FiltrosServices";
import moment from "moment/moment";
import { FaBackward, FaClinicMedical } from "react-icons/fa";
import { soloNumeros } from "../../Utils";
import { Plus, PlusCircle, Save, Trash } from "lucide-react";

export const InicioHemodialisis = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const pacientesEnfermera = JSON.parse(localStorage.getItem("auth")).confApp
    .pacientesEnfermera;

  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [api, contextHolder] = notification.useNotification();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const [fecha, setFecha] = useState("");
  const [horario, setHorario] = useState("");
  const [hora, setHora] = useState("");
  const [dataHorarios, setDataHorarios] = useState([]);
  const [idPaciente, setIdPaciente] = useState(0);
  const [dataPacientes, setDataPacientes] = useState([]);
  const [lugar, setLugar] = useState(0);
  const [estatus, setEstatus] = useState("");
  const [peso, setPeso] = useState(0);

  const [listaAsist, setListAsist] = useState([]);
  const [listAsistTurno, setListAsistTurno] = useState([]);
  const [open, setOpen] = useState(false);
  const [paciente, setPaciente] = useState("");
  const [idSesion, setIdSesion] = useState(0);
  const [openInsumos, setOpenInsumos] = useState(false);

  const [modalOpenAsigna, setModalOpenAsigna] = useState(false);
  const [opcAsigna, setOpcionAsigna] = useState("ENF");
  const [asignacion, setAsignacion] = useState("");
  const [idAsigna, setIdAsigna] = useState("");
  const [usoPositivo, setUsoPositivo] = useState(0);

  const [dataAsigna, setDataAsigna] = useState([]);

  const [idEntradaSesion, setIdEntradaSesion] = useState(null);
  const [stock, setStock] = useState(0);
  const [cantidad, setCantidad] = useState(0);
  const [dataInsumos, setDataInsumos] = useState([]);
  const [listInsumos, setListInsumos] = useState([]);
  const [dataTurnos, setDataTurnos] = useState([]);

  const [listInvent, setListInvent] = useState([]);
  const [idEntrada, setIdEntrada] = useState(null);
  const [modalidad, setModalidad] = useState(null);
  const [dataMaquina, setDataMaquina] = useState([]);
  const [idMaquina, setIdMaquina] = useState("");
  const [idTurno, setIdTurno] = useState("");
  const [estatusFiltro, setEstatusFiltro] = useState("");
  const [listModalidad, setListModalidad] = useState([
    { label: "NR - No Reuso", value: "NR - No Reuso" },
  ]);
  const [editando, setEditando] = useState(false);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const [loading, setLoading] = useState(false);

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const divMobile = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "1340px",
    height: "auto",
    padding: "5px",
    margin: "0 auto",
  };

  const eliminaRenglon = async (props) => {
    const data = {
      id: idNegocio,
      idSesion: idSesion,
      cantidad: props.cantidad,
      idInsumo: props.idInsumo,
      idEntrada: props.idEntrada,
    };
    await deleteInsumo(data)
      .then(async (res) => {
        await getInsumosSesion(idNegocio, idSesion).then(async (res) => {
          successNotification("Renglón", "Se ha eliminado el renglón...");
          setListInsumos(res);
          await getListaAsistencia(idNegocio, fecha, hora).then((res) => {
            setListAsist(res);
          });
        });
      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
      });
  };

  const openModalInsumos = (props) => {
    setIdSesion(props.idSesion);
    setPaciente(props.paciente);
    loadInsumos().then(async (next) => {
      await getInsumosSesion(idNegocio, props.idSesion).then((res) => {
        setListInsumos(res);
      });
    });
  };

  const fetchHorarios = async (e) => {
    if (e === null) {
      setDataHorarios([]);
      return;
    }

    setIdTurno(e);
    await getHorariosTurno(idNegocio, e)
      .then(async (res) => {
        setDataHorarios(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const saveAsignaModalFiltro = async () => {
    const data = {
      id: idNegocio,
      idPac: idPaciente,
      tipoAsigna: modalidad,
      idUSer: idUser,
    };

    await saveAsignaModalidadUso(data).then(async (res) => {
      if (res.data > 0) {
        setEstatusFiltro("Asignado");
        successNotification(
          "Asignación de modalidad",
          "Se han registrado los datos de forma correcta.",
        );
        setEstatusFiltro("Asignado");
        await getFiltrosXInventario(idNegocio).then((res) => {
          setListInvent(res);
        });
      }
    });
  };

  const loadTurnos = async (e) => {
    const _fecha = moment(e).format("YYYY-MM-DD");
    setFecha(_fecha);

    await getTurnos(idNegocio)
      .then((res) => {
        setDataTurnos(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const handleStock = async (e) => {
    if (e === null) {
      setIdEntradaSesion(null);
      setStock(0);
      return;
    }
    await getStockInsumo(idNegocio, 0, e)
      .then((res) => {
        setIdEntradaSesion(e);
        setStock(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleClose = () => {
    setIdEntradaSesion(null);
    setCantidad(0);
    setStock(0);
    setOpenInsumos(false);
  };

  const handleCloseAsigna = () => {
    setModalOpenAsigna(false);
  };

  const confirm = () =>
    new Promise(async (resolve) => {
      const data = {
        id: idNegocio,
        idPac: idPaciente,
        idEntrada: idEntrada,
        idUser: idUser,
        claveSerie: "",
      };
      await saveAsignaFiltro(data).then(async (res) => {
        if (res.data > 0) {
          successNotification(
            "Asignación",
            "Se asgino el filtro de forma correcta.",
          );
          setDataPacientes([]);
          await getPacientesProg(idNegocio, fecha, hora).then((res) => {
            setDataPacientes(res);
            setIdPaciente(0);
            setLugar(0);
            setModalidad("");
            setListModalidad([
              { label: "NR - No Reuso", value: "NR - No Reuso" },
              { label: "RU - Reuso", value: "RU - Reuso" },
            ]);
            setListInvent([]);
            setOpen(false);
          });
        } else {
          resolve(null);
          errorNotificaction(
            "Error_Asignacion",
            "Ocurrio un error al asignar.",
          );
        }
      });
    });

  const saveAsignaLugar = async () => {
    const data = {
      id: idNegocio,
      fechaCita: fecha,
      hora: horario,
      idPaciente: idPaciente,
      noLugar: lugar,
      peso: !peso ? 0 : peso,
      idUser: idUser,
      estatus: estatus,
    };

    await asignaLugar(data)
      .then(async (res) => {
        if (res.data > 0) {
          successNotification(
            "Asistencia",
            "Se asigno el lugar de forma correcta.",
          );
          setEditando(false);
          setIdPaciente("0");
          await getListaAsistenciaTurno(
            idNegocio,
            fecha,
            idTurno,
            horario,
          ).then(async (res) => {
            setListAsistTurno(res);
            setDataPacientes([]);
            await getPacientesProg(idNegocio, fecha, hora).then((res) => {
              setDataPacientes(res);
              setPeso(0);
              setLugar(0);
            });
          });
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const getPacientes = async (e) => {
    if (e === null) {
      setHora("");
      setHorario("");
      setListAsist([]);
      return;
    }

    setHora(e);
    setHorario(e.substring(0, 8));
    await getPacientesProg(idNegocio, fecha, e)
      .then(async (res) => {
        setDataPacientes(res);
        await getListaAsistenciaTurno(idNegocio, fecha, idTurno, e).then(
          (res) => {
            setListAsistTurno(res);
          },
        );
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const loadInsumos = async () => {
    await getInsumos(idNegocio).then((res) => {
      setDataInsumos(res);
      setOpenInsumos(true);
    });
  };

  const addInsumo = async () => {
    const data = {
      id: idNegocio,
      idSesion: idSesion,
      idInsumo: 0,
      idEntrada: idEntradaSesion,
      cantidad: cantidad,
      idUser: idUser,
    };
    await addInsumoSesion(data)
      .then(async (res) => {
        if (res.data > 0) {
          successNotification(
            "Insumo agregado",
            "Se agrego el insumo a la sesión del paciente.",
          );
          await getInsumosSesion(idNegocio, idSesion).then(async (res) => {
            setListInsumos(res);
            setIdEntradaSesion(null);
            setStock(0);
            setCantidad(0);
            await getListaAsistenciaTurno(
              idNegocio,
              fecha,
              idTurno,
              horario,
            ).then((res) => {
              setListAsistTurno(res);
            });
          });
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleOpenModalAsigna = async (props) => {
    setIdAsigna("");
    setIdMaquina("");
    setIdSesion(props.idSesion);
    setPaciente(props.paciente);
    setAsignacion(props.header);
    setDataAsigna([]);
    setDataMaquina([]);

    const _usoPositivo = props.estatusMedico === "Positivo" ? 1 : 0;
    setUsoPositivo(_usoPositivo);

    await getEnfermeras(idNegocio)
      .then((res) => {
        setDataAsigna([{ label: "*** SIN ASIGNACIÓN ***", value: null }]);
        setDataAsigna((prev) => [...prev, ...res]);
      })
      .then(async (res) => {
        await getMaquinas(idNegocio, _usoPositivo).then((res) => {
          setDataMaquina([{ label: "*** SIN ASIGNACIÓN ***", value: null }]);
          setDataMaquina((prev) => [...prev, ...res]);
          setLoading(false);
          setModalOpenAsigna(true);
        });
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const saveAsigna = async () => {
    setLoading(true);
    const data = {
      id: idNegocio,
      idSesion: idSesion,
      idAsigna: idAsigna,
      idMaquina: idMaquina,
      pacientesEnfermera: pacientesEnfermera,
    };

    await saveAsignacion(data)
      .then(async (res) => {
        if (res.data > 0) {
          successNotification(
            "Asignación",
            "Se ha actualizado la información de forma correcta",
          );

          setEditando(false);
          setEstatus("");
          setLugar(0);
          setPeso(0);

          await getListaAsistenciaTurno(
            idNegocio,
            fecha,
            idTurno,
            horario,
          ).then((res) => {
            setListAsistTurno(res);
            setModalOpenAsigna(false);
          });
        }
        if (res.data === -1) {
          setLoading(false);
          errorNotificaction(
            "Existente",
            "La enfermera(o), ha cumplido el número máximo de atención de pacientes.",
          );
        }
        if (res.data === -2) {
          setLoading(false);
          errorNotificaction(
            "Existente",
            "La maquina, ya existe en la lista de asistencia.",
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        errorNotificaction(err.name, err.message);
      });
  };

  const getEstatusFiltro = async (idPac) => {
    var result = "";
    await getFiltroAsignado(idNegocio, idPac).then((res) => {
      result = res;
    });

    return result;
  };

  const handleEditar = (props) => {
    setLugar(props.noLugar);
    setEditando(true);
    setIdPaciente(props.idPac);
    setPaciente(props.paciente);
    setEstatus("Asignado");
  };

  const handleGetLugar = async (e) => {
    if (e === null) {
      setIdPaciente(0);
      setLugar(0);
      return;
    }
    setIdPaciente(e);
    const selectedItem = dataPacientes.find((item) => item.value === e);
    const text = selectedItem.label;
    setPaciente(text);

    // const result = await getEstatusFiltro(e);

    // if (result === "Sin asignar") {
    //   setListModalidad([
    //     { label: "NR - No Reuso", value: "NR - No Reuso" },
    //     { label: "RU - Reuso", value: "RU - Reuso" },
    //   ]);
    //   setModalidad(null);
    //   setListInvent([]);
    //   setIdEntrada(null);
    //   setOpen(true);
    //   return;
    // }

    await getLugarSesion(idNegocio, fecha, horario, e)
      .then((res) => {
        setLugar(res.noLugar);
        setEstatus(res.estatus);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 750); // Update on resize
    };

    window.addEventListener("resize", handleResize);
    // Set up an interval to update the time every second
  }, []);

  return (
    <>
      <title>Inicio de Hemodiálisis - NefroSys</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Inicio de Hemodiálisis" },
        ]}
        selectedKey={"InicioHemodialisis"}
      >
        {contextHolder}
        <div style={isMobile ? divMobile : {}}>
          <Panel bordered header="Agenda de Horarios">
            <div className="row mb-2">
              <div
                className="col-lg-2 col-md-2 col-sm-2"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "150px",
                }}
              >
                <Text size={"sm"}>Fecha</Text>
                <CustomProvider locale={es_ES}>
                  <DatePicker block onChange={(e) => loadTurnos(e)} />
                </CustomProvider>
              </div>
              <div
                className="col-lg-2 col-md-2 col-sm-2"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "150px",
                }}
              >
                <Text>Turno</Text>
                <SelectPicker
                  block
                  placeholder="--Selecciona--"
                  searchable={false}
                  data={dataTurnos}
                  onChange={(e) => fetchHorarios(e)}
                />
              </div>
              <div
                className="col-lg-1 col-md-1 col-sm-1"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "150px",
                }}
              >
                <Text size={"sm"}>Horario</Text>
                <SelectPicker
                  searchable={false}
                  value={hora}
                  data={dataHorarios}
                  placeholder="--Horario--"
                  onChange={(e) => getPacientes(e)}
                />
              </div>
              <div
                className="col-lg-3 col-md-3 col-sm-3"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "350px",
                }}
              >
                <Text size={"sm"}>Paciente</Text>
                {!editando ? (
                  <SelectPicker
                    block
                    idPaciente={idPaciente}
                    data={dataPacientes}
                    onChange={(e) => handleGetLugar(e)}
                    placeholder="-- Selecciona --"
                  />
                ) : (
                  <Input readOnly value={paciente} />
                )}
              </div>
              <div
                className="text-center col-lg-1 col-md-1 col-sm-1"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "110px",
                }}
              >
                <Text size={"sm"}>Lugar</Text>
                <Input readOnly style={{ textAlign: "center" }} value={lugar} />
              </div>
              <div
                className="text-center col-lg-1 col-md-1 col-sm-1"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "110px",
                }}
              >
                <Text size={"sm"}>Estatus</Text>
                <Input
                  readOnly
                  style={{ textAlign: "center " }}
                  value={estatus}
                />
              </div>
              <div
                className="col-lg-1 col-md-1 col-sm-1"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "100px",
                }}
              >
                <Text>Peso inicial</Text>
                <Input
                  controls={false}
                  onClick={(e) => e.target.select()}
                  disabled={lugar === 0 ? true : false}
                  value={peso}
                  style={{ textAlign: "center" }}
                  onChange={(e) => setPeso(soloNumeros(e))}
                />
              </div>
              <div
                className="col-lg-1 col-md-1 col-sm-1"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "170px",
                }}
              >
                <br></br>
                <Button
                  block
                  type="primary"
                  icon={<FaClinicMedical></FaClinicMedical>}
                  disabled={lugar && peso >= 0 ? false : true}
                  onClick={saveAsignaLugar}
                >
                  {!editando ? "Asignar" : "Actualizar"}
                </Button>
              </div>
            </div>
          </Panel>
          <br></br>
          <Card
            title={
              <Text weight="bold" size={"lg"}>
                Turno:{" "}
                {idTurno === "MAT" ? (
                  <Tag size="lg" color="#CFF6FF">
                    MATUTINO
                  </Tag>
                ) : idTurno !== "" ? (
                  "VESPERTINO"
                ) : (
                  ""
                )}{" "}
                - Lista de asistencia ({moment(fecha).format("DD-MMM-YYYY")}) -
                Sesión de Hemodialisis
              </Text>
            }
          >
            <div className="row">
              {listAsistTurno.length > 0
                ? listAsistTurno.map((itm, index) => (
                    <div className="col" key={`col-${index}`}>
                      <Box mb={10}>
                        <Tag color="#1F3661" style={{ fontSize: "16px" }}>
                          <b>Horario:</b> {itm.hora.substring(0, 8)}
                        </Tag>
                      </Box>
                      <div className="border rounded-xl overflow-hidden">
                        <Table
                          key={`tbl-${index}`}
                          bordered
                          hover
                          responsive
                          size="sm"
                          style={{ fontSize: isMobile ? "12px" : "14px" }}
                        >
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>
                                <b>#</b>
                              </th>
                              <th>
                                <Text weight="semibold">Paciente</Text>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <Text weight="semibold">Insumos</Text>
                              </th>
                              <th>
                                <Text weight="semibold">Enfermera(o)</Text>
                              </th>
                              <th>
                                <Text weight="semibold">Maquina</Text>
                              </th>
                              <th>
                                <Text
                                  weight="semibold"
                                  style={{ textAlign: "center" }}
                                >
                                  Peso inicial
                                </Text>
                              </th>
                            </tr>
                          </thead>
                          {itm.lista.map((item, ix) => (
                            <tbody>
                              <tr id={`tr-${ix}`}>
                                <td
                                  key={`cell-No-${ix}`}
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatusMedico === "Positivo"
                                        ? "red"
                                        : item.estatusMedico === "Grave"
                                          ? "yellow"
                                          : item.estatusIngreso === "Nuevo"
                                            ? "lightgreen"
                                            : "#CFF6FF",
                                    color:
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black",
                                  }}
                                >
                                  <Text
                                    weight="bold"
                                    color={
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black"
                                    }
                                  >
                                    {item.no}
                                  </Text>
                                </td>
                                <td
                                  key={`cell-paciente-${index}`}
                                  style={{
                                    backgroundColor:
                                      item.estatusMedico === "Positivo"
                                        ? "red"
                                        : item.estatusMedico === "Grave"
                                          ? "yellow"
                                          : item.estatusIngreso === "Nuevo"
                                            ? "lightgreen"
                                            : "#CFF6FF",
                                    color:
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black",
                                  }}
                                >
                                  <Text
                                    color={
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black"
                                    }
                                  >
                                    <Button
                                      type="text"
                                      onClick={() =>
                                        handleEditar({
                                          noLugar: item.no,
                                          idPac: item.idPaciente,
                                          paciente: item.paciente,
                                        })
                                      }
                                      style={{
                                        color:
                                          item.estatusMedico === "Positivo"
                                            ? "white"
                                            : "black",
                                      }}
                                    >
                                      {item.paciente}
                                    </Button>
                                  </Text>
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor:
                                      item.estatusMedico === "Positivo"
                                        ? "red"
                                        : item.estatusMedico === "Grave"
                                          ? "yellow"
                                          : item.estatusIngreso === "Nuevo"
                                            ? "lightgreen"
                                            : "#CFF6FF",
                                    color:
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black",
                                  }}
                                >
                                  <Text
                                    color={
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black"
                                    }
                                  >
                                    <Button
                                      type="text"
                                      key={`btnInsumos-${ix}`}
                                      icon={<Plus size={12}></Plus>}
                                      style={{
                                        color:
                                          item.estatusMedico === "Positivo"
                                            ? "white"
                                            : "black",
                                      }}
                                      onClick={() =>
                                        openModalInsumos({
                                          idSesion: item.idSesion,
                                          paciente: item.paciente,
                                        })
                                      }
                                    >
                                      {item.insumos}
                                    </Button>
                                  </Text>
                                </td>
                                <td
                                  key={`cell-enfermera`}
                                  style={{
                                    backgroundColor:
                                      item.estatusMedico === "Positivo"
                                        ? "red"
                                        : item.estatusMedico === "Grave"
                                          ? "yellow"
                                          : item.estatusIngreso === "Nuevo"
                                            ? "lightgreen"
                                            : "#CFF6FF",
                                    color:
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black",
                                  }}
                                >
                                  <Text
                                    color={
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black"
                                    }
                                  >
                                    <Button
                                      type="text"
                                      key={`btnEnfermera-${ix}`}
                                      icon={<Plus size={12}></Plus>}
                                      style={{
                                        color:
                                          item.estatusMedico === "Positivo"
                                            ? "white"
                                            : "black",
                                      }}
                                      onClick={() =>
                                        handleOpenModalAsigna({
                                          idSesion: item.idSesion,
                                          paciente: item.paciente,
                                          opc: "ENF",
                                          header: "Enfermera(o)",
                                          estatusMedico: item.estatusMedico,
                                        })
                                      }
                                    >
                                      {item.enfermera}
                                    </Button>
                                  </Text>
                                </td>
                                <td
                                  key={`cell-maquina`}
                                  style={{
                                    backgroundColor:
                                      item.estatusMedico === "Positivo"
                                        ? "red"
                                        : item.estatusMedico === "Grave"
                                          ? "yellow"
                                          : item.estatusIngreso === "Nuevo"
                                            ? "lightgreen"
                                            : "#CFF6FF",
                                    color:
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black",
                                  }}
                                >
                                  <Text
                                    color={
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black"
                                    }
                                  >
                                    <Button
                                      type="text"
                                      key={`btnMaquina-${ix}`}
                                      icon={<Plus size={12}></Plus>}
                                      style={{
                                        color:
                                          item.estatusMedico === "Positivo"
                                            ? "white"
                                            : "black",
                                      }}
                                      onClick={() =>
                                        handleOpenModalAsigna({
                                          idSesion: item.idSesion,
                                          paciente: item.paciente,
                                          opc: "MAQ",
                                          header: "Maquina",
                                          estatusMedico: item.estatusMedico,
                                        })
                                      }
                                    >
                                      {item.maquina}
                                    </Button>
                                  </Text>
                                </td>
                                <td
                                  key={`cell-maquina`}
                                  style={{
                                    backgroundColor:
                                      item.estatusMedico === "Positivo"
                                        ? "red"
                                        : item.estatusMedico === "Grave"
                                          ? "yellow"
                                          : item.estatusIngreso === "Nuevo"
                                            ? "lightgreen"
                                            : "#CFF6FF",
                                    color:
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black",
                                    textAlign: "center",
                                  }}
                                >
                                  <Text
                                    color={
                                      item.estatusMedico === "Positivo"
                                        ? "white"
                                        : "black"
                                    }
                                  >
                                    <Button
                                      type="text"
                                      key={`btnMaquina-${ix}`}
                                      style={{
                                        color:
                                          item.estatusMedico === "Positivo"
                                            ? "white"
                                            : "black",
                                      }}
                                      onClick={() =>
                                        handleEditar({
                                          noLugar: item.no,
                                          idPac: item.idPaciente,
                                          paciente: item.paciente,
                                        })
                                      }
                                    >
                                      {item.pesoIngreso}
                                    </Button>
                                  </Text>
                                </td>
                              </tr>
                            </tbody>
                          ))}
                        </Table>
                      </div>
                      <HStack>
                        <Box mb={2} bg={"red"} p={10} w={10} h={10} /> Positivo
                        <Box mb={2} p={10} w={10} h={10} />
                        <Box mb={2} bg={"#FBFF2B"} p={10} w={10} h={10} /> Grave
                        <Box mb={2} p={10} w={10} h={10} />
                        <Box mb={2} bg={"#6CE065"} p={10} w={10} h={10} />{" "}
                        Paciente nuevo
                      </HStack>
                    </div>
                  ))
                : ""}
            </div>
          </Card>
        </div>
        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DRAWER DE ASIGNACIÓN DE FILTRO <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Drawer size={"lg"} open={open} onClose={() => setOpen(false)}>
          <Drawer.Header>
            <Drawer.Title>
              Aignación de Modalidad y Filtro: {paciente}
            </Drawer.Title>
            <Drawer.Actions>
              <Button
                startIcon={<FaBackward></FaBackward>}
                onClick={() => setOpen(false)}
              >
                Regresar
              </Button>
            </Drawer.Actions>
          </Drawer.Header>
          <Drawer.Body>
            <div className="row mb-3">
              <div className="col">
                <Card title="Selecciona la modalidad de uso en cada sesión">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <Text size={"md"}>Modalidad de uso (Filtro)</Text>
                      <SelectPicker
                        data={listModalidad}
                        searchable={false}
                        block
                        value={modalidad}
                        onChange={(e) => setModalidad(e)}
                        placeholder="-- Selecciona --"
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <br></br>
                      <Button
                        disabled={
                          idPaciente > 0 && modalidad !== null ? false : true
                        }
                        onClick={saveAsignaModalFiltro}
                        icon={<Save size={16}></Save>}
                        type="primary"
                        block
                      >
                        Guardar
                      </Button>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <Card title="Asignación de Filtro Dializador">
                  <div className="row">
                    <div className="col-lg-10 col-md-10 col-sm-10">
                      <Text>Filtro</Text>
                      <SelectPicker
                        data={listInvent}
                        block
                        value={idEntrada}
                        onChange={(e) => setIdEntrada(e)}
                        placeholder="-- SELECCIONA --"
                        disabled={estatusFiltro === "Asignado" ? false : true}
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <br></br>
                      <Popconfirm
                        placement="leftTop"
                        title="Asignar filtro"
                        description="¿Esta seguro de asignar eset filtro al paciente?"
                        okText="Si"
                        onConfirm={confirm}
                        cancelText="No"
                      >
                        <Button
                          color="red"
                          icon={<Save size={16}></Save>}
                          type="primary"
                          disabled={idEntrada === null ? true : false}
                        >
                          Asignar
                        </Button>
                      </Popconfirm>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </Drawer.Body>
        </Drawer>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL AGREGA INSUMOS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          backdrop={"static"}
          keyboard={true}
          size={"lg"}
          open={openInsumos}
          onClose={handleClose}
        >
          <Modal.Header>
            <Modal.Title>
              Agregar insumos a la sesión No. {idSesion} / Paciente: {paciente}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row mb-2">
                <div className="col-lg-7 col-md-7 col-sm-7">
                  <Text>Insumo</Text>
                  <SelectPicker
                    block
                    value={idEntradaSesion}
                    data={dataInsumos}
                    onChange={(e) => handleStock(e)}
                    placeholder="-- Selecciona --"
                  />
                </div>
                <div className="text-center col-lg-2 col-md-2col-sm-2">
                  <Text>Stock</Text>
                  <Input
                    readOnly
                    value={stock}
                    style={{ textAlign: "center" }}
                  />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Text>Cantidad</Text>
                  <Input
                    value={cantidad}
                    style={{ textAlign: "center" }}
                    onFocus={(event) => event.target.select()}
                    onChange={(e) => setCantidad(soloNumeros(e))}
                    controls={false}
                  />
                </div>
                <div className="text-end col-lg-1 col-md-1 col-sm-1">
                  <br></br>
                  <Button
                    type="primary"
                    block
                    disabled={
                      idEntradaSesion !== null && cantidad > 0 ? false : true
                    }
                    onClick={addInsumo}
                    icon={<PlusCircle size={16}></PlusCircle>}
                  ></Button>
                </div>
              </div>
            </Panel>
            <br></br>
            <Panel bordered header="Detalle de Insumos">
              <div className="row">
                <div className="col">
                  <Table
                    striped
                    bordered
                    hover
                    responsive
                    style={{ fontSize: "16px" }}
                  >
                    <thead>
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          <Text weight="semibold">#</Text>
                        </td>
                        <td>
                          <Text weight="semibold">
                            Insumo (Material o Medicamento)
                          </Text>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Text weight="semibold">Cantidad</Text>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Text weight="semibold">Acción</Text>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {listInsumos.length > 0
                        ? listInsumos.map((item, index) => {
                            return (
                              <tr>
                                <td style={{ textAlign: "center" }}>
                                  {Number(index) + 1}
                                </td>
                                <td>{item.insumo}</td>
                                <td style={{ textAlign: "center" }}>
                                  {item.cantidad}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  <Button
                                    key={`btn-${index}`}
                                    style={{ color: "red" }}
                                    onClick={() =>
                                      eliminaRenglon({
                                        idInsumo: item.idInsumo,
                                        cantidad: item.cantidad,
                                        idEntrada: item.idEntrada,
                                      })
                                    }
                                    icon={<Trash size={16}></Trash>}
                                    size="sm"
                                  />
                                </td>
                              </tr>
                            );
                          })
                        : ""}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleClose}
              type="default"
              icon={<FaBackward></FaBackward>}
            >
              Regresar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL ASIGNACION <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          backdrop={"static"}
          keyboard={true}
          size={"md"}
          open={modalOpenAsigna}
          onClose={handleCloseAsigna}
        >
          <Modal.Header>
            <Modal.Title>
              Asignar {asignacion} a la sesión No. {idSesion} / Paciente:{" "}
              {paciente}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <Grid fluid>
                <Row spacing={10}>
                  <Col span={24}>
                    <Text weight="semibold">Enfermero(a)</Text>
                    <SelectPicker
                      block
                      value={idAsigna}
                      data={dataAsigna}
                      onChange={(e) => setIdAsigna(e)}
                      placeholder="-- Selecciona --"
                    />
                  </Col>
                </Row>
                <br></br>
                <Row spacing={10}>
                  <Col span={24}>
                    <Text weight="semibold">Maquina</Text>
                    <SelectPicker
                      block
                      value={idMaquina}
                      data={dataMaquina}
                      onChange={(e) => setIdMaquina(e)}
                      placeholder="-- Selecciona --"
                    />
                  </Col>
                </Row>
              </Grid>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleCloseAsigna}
              type="default"
              icon={<FaBackward></FaBackward>}
            >
              Regresar
            </Button>
            <Button
              type="primary"
              loading={loading}
              disabled={idAsigna !== "" && idMaquina !== "" ? false : true}
              onClick={saveAsigna}
              icon={<Save size={16}></Save>}
            >
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
      </LayoutHome>
    </>
  );
};
